// reducer.js
import { success } from 'toastr';
import {
  FETCH_EMPLOYEES_REQUEST,
  FETCH_EMPLOYEES_SUCCESS,
  FETCH_EMPLOYEES_FAILURE,
  CREATE_EMPLOYEE_REQUEST,
  CREATE_EMPLOYEE_SUCCESS,
  CREATE_EMPLOYEE_FAILURE,
  EMPLOYEE_DROPDOWN_REQUEST,
  EMPLOYEE_DROPDOWN_SUCCESS,
  EMPLOYEE_DROPDOWN_FAILURE,
  EMPLOYEE_DROPDOWN_AUTO_LIST_REQUEST,
  EMPLOYEE_DROPDOWN_AUTO_LIST_SUCCESS,
  EMPLOYEE_DROPDOWN_AUTO_LIST_FAILURE,
  FETCH_EMPLOYEE_TAB_WISE_INFO,
  FETCH_EMPLOYEE_TAB_WISE_INFO_SUCCESS,
  FETCH_EMPLOYEE_TAB_WISE_INFO_FAILURE,
  DELETE_DOCUMENT_REQUEST,
  DELETE_DOCUMENT_SUCCESS,
  DELETE_DOCUMENT_FAILURE,
  FETCH_ACTIVE_EMPLOYEES_REQUEST,
  FETCH_ACTIVE_EMPLOYEES_SUCCESS,
  FETCH_ACTIVE_EMPLOYEES_FAILURE,
  FETCH_EMPLOYEE_VIEW_PROFILE_REQUEST,
  FETCH_EMPLOYEE_VIEW_PROFILE_SUCCESS,
  FETCH_EMPLOYEE_VIEW_PROFILE_FAILURE,
  FETCH_TRANSFER_TYPES,
  FETCH_TRANSFER_TYPES_SUCCESS,
  FETCH_TRANSFER_TYPES_FAILURE,
  FETCH_FROM_CATEGORY,
  FETCH_FROM_CATEGORY_SUCCESS,
  FETCH_FROM_CATEGORY_FAILURE,
  FETCH_FROM_DESIGNATION,
  FETCH_FROM_DESIGNATION_SUCCESS,
  FETCH_FROM_DESIGNATION_FAILURE,
  FETCH_FROM_DEPARTMENT_SUCCESS,
  FETCH_FROM_DEPARTMENT_FAILURE,
  FETCH_TRANSFERLOGS,
  FETCH_TRANSFERLOGS_SUCCESS,
  FETCH_TRANSFERLOGS_FAILURE,
  FETCH_EMPLOYEELISTTOTRANSFER,
  FETCH_EMPLOYEELISTTOTRANSFER_SUCCESS,
  FETCH_EMPLOYEELISTTOTRANSFER_FAILURE,
  CLEAR_EMPLOYEE_LIST,
  FETCH_FROM_DEPARTMENT,
  FETCH_REPORTING,
  FETCH_REPORTING_SUCCESS,
  FETCH_REPORTING_FAILURE,
  GET_SHIFT_GROUP_DETAILS_FAILURE,
  GET_SHIFT_GROUP_DETAILS_SUCCESS,
  GET_SHIFT_GROUP_DETAILS,
  SAVE_TRANSFER_REQUEST,
  SAVE_TRANSFER_SUCCESS,
  SAVE_TRANSFER_FAILURE,
  EMPLOYEE_DROPDOWN_AUTO_LIST_EXTRADUTY_REQUEST,
  EMPLOYEE_DROPDOWN_AUTO_LIST_EXTRADUTY_SUCCESS,
  EMPLOYEE_DROPDOWN_AUTO_LIST_EXTRADUTY_FAILURE,
  FETCH_NEXT_EMP_NO_REQUEST,
  FETCH_NEXT_EMP_NO_SUCCESS,
  FETCH_NEXT_EMP_NO_FAILURE,
  EMPLOYEE_DROPDOWN_AUTO_LIST_MOBILEPUNCH_REQUEST,
  EMPLOYEE_DROPDOWN_AUTO_LIST_MOBILEPUNCH_SUCCESS,
  EMPLOYEE_DROPDOWN_AUTO_LIST_MOBILEPUNCH_FAILURE,
} from './actionTypes';

const initialState = {
  employees: [],
  employeesActiveList: [],
  dropdownData: [],
  dropdownAutoList: [],
  loading: false,
  error: null,
  emp_id: 0,
  employeeTabData: {},
  profile: null,
  success: false,
  transfer_type: [],
  categoryList: [],
  designationList: [],
  departmentList: [],
  reportList: [],
  employeeList: [],
  transferList: [],
  transferLogs: [],
  clearList: [],
  shiftDetails: [],
  dropdownAutoExtraDutyList: [],
  nextEmpNo: [],

};

const employeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EMPLOYEES_REQUEST:
    case CREATE_EMPLOYEE_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
      };
    case FETCH_EMPLOYEES_SUCCESS:
      return {
        ...state,
        loading: false,
        emp_id: 0,
        employees: action.payload.data,
        employeeTabData: state.employeeTabData || {},
      };
    case CREATE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        loading: false,
        employees: [...state.employees, action.payload],
        emp_id: action.payload.empid,
        success: true,
      };
    case FETCH_EMPLOYEES_FAILURE:
    case CREATE_EMPLOYEE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case EMPLOYEE_DROPDOWN_REQUEST:
      return { ...state, loading: true, error: null };

    case EMPLOYEE_DROPDOWN_SUCCESS:
      return { ...state, loading: false, dropdownData: action.payload.data };

    case EMPLOYEE_DROPDOWN_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case EMPLOYEE_DROPDOWN_AUTO_LIST_REQUEST:
      return { ...state, loading: true, error: null };

    case EMPLOYEE_DROPDOWN_AUTO_LIST_SUCCESS:
      return { ...state, loading: false, dropdownAutoList: action.payload.data.emp_No };

    case EMPLOYEE_DROPDOWN_AUTO_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case FETCH_EMPLOYEE_TAB_WISE_INFO:
      return { ...state, loading: true, error: null };

    case FETCH_EMPLOYEE_TAB_WISE_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        employeeTabData: {
          ...state.employeeTabData,
          [action.payload.tabName]: action.payload.data || [],
        },
      };

    case FETCH_EMPLOYEE_TAB_WISE_INFO_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case DELETE_DOCUMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case DELETE_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case DELETE_DOCUMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case FETCH_ACTIVE_EMPLOYEES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_ACTIVE_EMPLOYEES_SUCCESS:
      return {
        ...state,
        loading: false,
        employeesActiveList: (action.payload?.data?.emp_No).map(emp => ({
          value: emp.emp_id,
          label: emp.emp_no
        })),
      };
    case FETCH_ACTIVE_EMPLOYEES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case FETCH_EMPLOYEE_VIEW_PROFILE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    case FETCH_EMPLOYEE_VIEW_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        profile: action.payload,
        success: false,
      };
    case FETCH_EMPLOYEE_VIEW_PROFILE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case CLEAR_EMPLOYEE_LIST:
      return {
        ...state,
        loading: false,
        clearList: [],
      };
    //Dinesh Starting--------------------------------------------------------------------------------- //
    case FETCH_TRANSFER_TYPES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_TRANSFER_TYPES_SUCCESS:
      return {
        ...state,
        loading: true,
        error: null,
        transfer_type: action.payload.data?.transfer_type
      };
    case FETCH_TRANSFER_TYPES_FAILURE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_FROM_CATEGORY:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_FROM_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: true,
        error: null,
        categoryList: action.payload.data
      };
    case FETCH_FROM_CATEGORY_FAILURE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_FROM_DESIGNATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_FROM_DESIGNATION_SUCCESS:
      return {
        ...state,
        loading: true,
        error: null,
        designationList: action.payload.data
      };
    case FETCH_FROM_DESIGNATION_FAILURE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    //FETCH_FROM_DEPARTMENT
    case FETCH_FROM_DEPARTMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_FROM_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loading: true,
        error: null,
        departmentList: action.payload.data
      };
    case FETCH_FROM_DEPARTMENT_FAILURE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_TRANSFERLOGS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_TRANSFERLOGS_SUCCESS:
      return {
        ...state,
        loading: true,
        error: null,
        transferLogs: action.payload.data
      };
    case FETCH_TRANSFERLOGS_FAILURE:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_EMPLOYEELISTTOTRANSFER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_EMPLOYEELISTTOTRANSFER_SUCCESS:
      return {
        ...state,
        loading: true,
        error: null,
        employeeList: action.payload.data
      };
    case FETCH_EMPLOYEELISTTOTRANSFER_FAILURE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_REPORTING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_REPORTING_SUCCESS:
      return {
        ...state,
        loading: true,
        error: null,
        reportList: action.payload.data?.approve_by
      };
    case FETCH_REPORTING_FAILURE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    // ------------------------------------------------Dinesh End--------------------------------------------------------------
    case GET_SHIFT_GROUP_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_SHIFT_GROUP_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        shiftDetails: action.payload?.data || [],
      };

    case GET_SHIFT_GROUP_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SAVE_TRANSFER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case SAVE_TRANSFER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: true,
        data: action.payload,
      };

    case SAVE_TRANSFER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case EMPLOYEE_DROPDOWN_AUTO_LIST_EXTRADUTY_REQUEST:
      return { ...state, loading: true, error: null };

    case EMPLOYEE_DROPDOWN_AUTO_LIST_EXTRADUTY_SUCCESS:
      return { ...state, loading: false, dropdownAutoExtraDutyList: action.payload.data.emp_No };

    case EMPLOYEE_DROPDOWN_AUTO_LIST_EXTRADUTY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case FETCH_NEXT_EMP_NO_REQUEST:
      return { ...state, loading: true };

    case FETCH_NEXT_EMP_NO_SUCCESS:
      return { ...state, loading: false, nextEmpNo: action.payload };

    case FETCH_NEXT_EMP_NO_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case EMPLOYEE_DROPDOWN_AUTO_LIST_MOBILEPUNCH_REQUEST:
      return { ...state, loading: true, error: null };

    case EMPLOYEE_DROPDOWN_AUTO_LIST_MOBILEPUNCH_SUCCESS:
      return { ...state, loading: false, dropdownAutoMobilepunchList: action.payload.data.emp_No };

    case EMPLOYEE_DROPDOWN_AUTO_LIST_MOBILEPUNCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default employeeReducer;
